import React from 'react';
import { FieldHookConfig, useField } from 'formik';
import { Text, VStack } from '@adc/parallax-component-library';
import './Select.scss';

export type SelectOption = {
  id: string;
  name: string;
};

type Props = {
  options: SelectOption[];
  label: string | undefined;
  disabled?: boolean;
  width?: string;
};
const Select = ({
  options,
  label,
  disabled = false,
  width,
  testID,
  ...rest
}: Props & FieldHookConfig<string>) => {
  const [field, meta] = useField(rest);

  return (
    <VStack gap="$2" width={width}>
      {label ? (
        <Text type="$bodySmall.default" color="$text.60" textAlign="left">
          {label}
        </Text>
      ) : null}
      <span className={`select-wrapper ${width ? '' : ' default-width'}`}>
        <select
          className={`${meta.touched && meta.error ? 'error' : ''}`}
          disabled={disabled}
          {...field}
          data-testid={testID}
        >
          {options.map((option) => (
            <option value={option.id} key={option.id}>
              {option.name}
            </option>
          ))}
        </select>
      </span>
      {meta.touched && meta.error ? (
        <Text
          type="$bodySmall.default"
          color="$support.danger.surfaceOnColorAlt"
          textAlign="left"
        >
          {meta.error}
        </Text>
      ) : null}
    </VStack>
  );
};

export default Select;
